<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Account Verification</h5>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                            Company Legal Name
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.name}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Brand Name
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.brandName}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Email Address
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.email}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                          Phone Number
                        </div>
                        <div class="table-cell w-3/5 p-4">
                          : {{merchantInfo.phone}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Address
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.address}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-w-2/5 p-4">Web Address</div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.webAddress}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Name
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{merchantInfo.directorName}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Identity
                        </div>
                        <div class="table-cell w-3/5 p-4">
                          <span v-if="merchantInfo.directorIdentityType=='1'">
                            : KTP - {{merchantInfo.directorIdentityNumber}}
                          </span>
                          <span v-else-if="merchantInfo.directorIdentityType=='2'">
                            : Passport - {{merchantInfo.directorIdentityNumber}}
                          </span>
                          <span v-else>
                            : {{merchantInfo.directorIdentityNumber}}
                          </span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                          Are your business apply work shift ?
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            :
                            <vs-radio id="rdo-shift-yes" :disabled="has_shift_disabled" v-model="merchantInfo.config.has_shift" vs-value="true">Yes</vs-radio>
                            &nbsp;&nbsp;
                            <vs-radio id="rdo-shift-no" :disabled="has_shift_disabled" v-model="merchantInfo.config.has_shift" vs-value="false">No</vs-radio>
                        </div>
                    </div>

                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                           Merchant has consolidation file?
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            :
                            <vs-radio id="rdo-has-fk-yes" disabled="true" v-model="merchantHasFk" vs-value="yesfk" >yes</vs-radio>
                            &nbsp;&nbsp;
                            <vs-radio id="rdo-has-fk-no" disabled="true" v-model="merchantHasFk" vs-value="nofk" >no</vs-radio>
                        </div>
                    </div>

                    <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                        <div class="table-cell w-2/5 p-4">
                            Max time sending consolidation file
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : {{ consolidationProcessTime }}
                        </div>
                    </div>

                    <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                        <div class="table-cell w-2/5 p-4">
                            Consolidation emails notification
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            : <b style="font-weight:700;color:#636363;">Email added</b>
                            <div class="w-full flex flex-wrap" :key="ind" v-for="(data, ind) in merchantConsolidationEmails">
                                <div class="w-full py-2 flex flex-wrap">
                                    <div class="w-full px-3 py-1" style="word-break: break-word;">
                                        <feather-icon
                                            icon="MailIcon"
                                            svgClasses="h-3 w-5"
                                            class="cursor-hand"
                                        />
                                        {{data}}
                                    </div>
                                    <!-- <div class="w-4/5 px-3 py-1" style="word-break: break-word;">
                                        {{data}}
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Status
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="vertical-center">
                                <vs-chip v-bind:color="statusColor">
                                    <vs-avatar style="background: hsla(0, 0%, 100%, .2)" v-bind:icon="statusIcon"/>
                                    {{statusText}}
                                </vs-chip>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>
            <div class="w-full">
                <div class="w-5/5">
                    <div class="flex flex-wrap w-full mb-5">
                        <div class="w-1/5 p-4">Legality Documents</div>
                        <div class="w-3/5 flex flex-wrap">
                            <div class="w-full">
                                <vs-list v-if="merchantDocuments">
                                    <vs-list-item v-for="item,k in merchantDocuments" icon="attachment"  v-bind:key="item.name"
                                                  v-bind:title="item.name">
                                        <vs-button v-bind:id="'btn-download-'+k" v-if="item.url" target="true" v-bind:href="baseUrlDownload+item.url"
                                                   color="primary">
                                            download
                                        </vs-button>

                                        <h4 v-else>N/A</h4>
                                    </vs-list-item>
                                </vs-list>
                                <h4 v-else>N/A</h4>
                            </div>
                            <div class="w-full">

                            </div>
                            <div class="w-full">

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="w-full flex flex-no-wrap">
              <div class="w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;AINO AS a*</span>
                  </div>
                  <div class="vx-col sm" style="padding-right: 2px">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full" style="padding-left: 3px">
                    <vs-radio id="rdo-business-status-ma" :disabled="business_status_disabled" v-model="merchantInfo.business_status" vs-name="business_status" vs-value="MA">Merchant Aggregator</vs-radio>
                    &nbsp;&nbsp;
                    <vs-radio id="rdo-business-status-facilitator" :disabled="business_status_disabled" v-model="merchantInfo.business_status" vs-name="business_status" vs-value="FA">Facilitator</vs-radio>
                    <br>
                    &nbsp;&nbsp;* contact to merchant or business team
                  </div>
                </div>
              </div>
            </div>

        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-cancel" type="border" @click="cancelAction">Cancel</vs-button>
                <vs-button id="btn-reject" class="ml-4" v-if="merchantInfo.status !== 'active'" @click="showPrompt = true">Reject</vs-button>
                <vs-button id="btn-approve" class="ml-4" v-if="merchantInfo.status !== 'active'" @click="approveAction">Approve</vs-button>
            </div>
        </vx-card>
        <vs-prompt
                @vs-cancel="clearVal"
                @vs-accept="rejectAction"
                :vs-is-valid="validName"
                :vs-active.sync="showPrompt">
            <div class="con-exemple-prompt">
                Enter your reason to <b>reject</b>.
                <vs-input placeholder="Reason, e.g:Document is incomplete, etc " v-model="notes" class="mt-4 mb-2 w-full" />

                <vs-alert :vs-active="!validName" color="danger" vs-icon="new_releases" >
                    Fields can not be empty please enter the reason
                </vs-alert>
            </div>
        </vs-prompt>
    </div>

</template>

<script>
    import MerchantAPI from "@/network/api/MerchantAPI";
    import {url} from "@/configs/apiUrl"
    import swal from 'sweetalert2'

    export default {
        data() {
            return {
                baseUrlDownload: url.content_delivery.base,
                merchantInfo: {
                    id: '',
                    name: "",
                    brandName: "",
                    email: "",
                    address: "",
                    webAddress: "",
                    directorName: "",
                    directorIdentityType: "",
                    directorIdentityNumber: "",
                    status: '',
                    phone: '',
                    business_status: '',
                    config:{}
                },
                merchantCredential: {
                    midAino: ''
                },
                merchantDocuments: [],
                identityTypes: [
                    {
                        id: 1,
                        name: "KTP"
                    },
                    {
                        id: 2,
                        name: "Passport"
                    }
                ],
                statusIcon: '',
                statusColor: '',
                statusText: '',
                showPrompt:false,
                notes:'',
                business_status_disabled: false,
                has_shift_disabled: false,
                merchantHasFk: "",
                showMerchantConsolidationConfigs: false,
                consolidationProcessTime: null,
                merchantConsolidationEmails: [],
            }
        },
        computed: {
            validateForm() {
                return (
                    !this.errors.any() &&
                    this.merchantInfo.name != "" &&
                    this.merchantInfo.brandName != "" &&
                    this.merchantInfo.email != "" &&
                    this.merchantInfo.address != "" &&
                    this.merchantInfo.directorName != "" &&
                    this.merchantInfo.directorIdentityType != "" &&
                    this.merchantInfo.directorIdentityNumber != ""
                );
            },
            validName(){
                  return this.notes.length > 0
            }
        },
        methods: {
            clearVal(){
                this.notes =''
            },
            cancelAction() {
                this.$router.push({name:'merchantVerificcation'});
            },
            approveAction() {
                if (this.merchantInfo.business_status=='') {
                  swal.fire({
                    type: 'warning',
                    title: 'Alert',
                    text: 'Mandatory field must be filled!',
                  })
                  return false
                }

                let config = {}
                config = this.merchantInfo.config

                config.has_shift =((this.merchantInfo.config.has_shift === "true") ? true : false)
                
                let payload = {
                  id: this.merchantInfo.id,
                  
                  merchantInfo: {
                    status: 'active',
                    notes:'',
                    business_status: this.merchantInfo.business_status,
                    config:config,
                  }
                }

                let dataBefore = {
                    id: this.merchantInfo.id,
                    merchantInfo: {
                        status: this.merchantInfo.status,
                        notes:'',
                        business_status: this.merchantInfo.business_status,
                        config:config,
                    }
                }

                MerchantAPI.Update(payload).then(() => {
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Merchant Verification",
                        activity: "Approve Merchant",
                        data_before: dataBefore,
                        data_after: payload,
                    })
                    this.$router.push({name:'merchantVerificcation'});
                })
            },
            rejectAction() {
                if (this.merchantInfo.business_status=='') {
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'Mandatory field must be filled!',
                    })
                    return false
                }

                let dataBefore = {
                    id: this.merchantInfo.id,
                    merchantInfo: {
                        status: this.merchantInfo.status,
                        notes:'',
                        business_status: this.merchantInfo.business_status,
                    }
                }

                let payload = {
                    id: this.merchantInfo.id,
                    merchantInfo: {
                        status: 'reject',
                        notes: this.notes,
                        business_status: this.merchantInfo.business_status
                    }
                }
                MerchantAPI.Update(payload).then(() => {
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Merchant Verification",
                        activity: "Reject Merchant",
                        data_before: dataBefore,
                        data_after: payload,
                    })
                    this.$router.push({name:'merchantVerificcation'});
                })
            },
            renderStatusUi(status) {
                if (status !== 'registered' && status !== null && status !== undefined && status != '') {
                    if (status === 'pending') {
                        this.statusColor = 'warning'
                        this.statusText = 'Waiting for verified'
                        this.statusIcon = 'hourglass_full'
                    } else if (status === 'reject') {
                        this.statusColor = 'danger'
                        this.statusText = 'Rejected'
                        this.statusIcon = 'close'
                    } else {
                        this.statusColor = 'success'
                        this.statusText = 'Verified'
                        this.statusIcon = 'verified_user'
                    }
                } else {
                    this.statusColor = 'dark'
                    this.statusText = 'Not verified'
                    this.statusIcon = 'lock'
                }
            }
        },
        mounted() {
            MerchantAPI.MerchantDetail({id: this.$route.params.id}).then((result) => {
                if (result.data !== null) {
                    for (let merchant of result.data) {
                        this.merchantInfo.id = merchant.id
                        this.merchantInfo.name = merchant.full_name
                        this.merchantInfo.brandName = merchant.brand_name
                        this.merchantInfo.email = merchant.email
                        this.merchantInfo.phone = merchant.phone
                        this.merchantInfo.webAddress = merchant.url
                        this.merchantInfo.status = merchant.status
                        this.merchantInfo.business_status = merchant.business_status
                        this.merchantInfo.config = merchant.config

                        // if (typeof merchant.config.has_shift == "boolean") {
                        //   if (merchant.config.has_shift==true) {
                        //     this.merchantInfo.config.has_shift="true"
                        //   } else {
                        //     this.merchantInfo.config.has_shift="false"
                        //   }
                        // } else {
                        //   this.merchantInfo.config.has_shift="false"
                        // }

                        //if (merchant.config.has_shift!==null) {

                        if (this.merchantInfo.config!=null) {

                            if (merchant.config.hasOwnProperty('has_shift')) {
                                if (this.merchantInfo.config.has_shift===true) {
                                this.merchantInfo.config.has_shift="true"
                                } else {
                                this.merchantInfo.config.has_shift="false"
                                }
                                //this.merchantInfo.config.has_shift="true"
                            } else {
                                this.merchantInfo.config.has_shift="false"
                            }

                            if (merchant.config.hasOwnProperty('merchant_has_fk')) {
                                if (this.merchantInfo.config.merchant_has_fk === true) {
                                    this.merchantHasFk="yesfk"
                                    this.showMerchantConsolidationConfigs = true
                                } else {
                                    this.merchantHasFk = "nofk"
                                    this.showMerchantConsolidationConfigs = false
                                }
                            } else {
                                this.merchantHasFk = "nofk"
                                this.showMerchantConsolidationConfigs = false
                            }

                            if (merchant.config.hasOwnProperty('consolidation_process_time')) {
                                if (this.merchantInfo.config.consolidation_process_time !== "") {
                                    this.consolidationProcessTime = this.merchantInfo.config.consolidation_process_time
                                } else {
                                    this.consolidationProcessTime = null
                                }
                            } else {
                                this.consolidationProcessTime = null
                            }

                            if (merchant.config.hasOwnProperty('merchant_consolidation_emails')) {
                                if (typeof this.merchantInfo.config.merchant_consolidation_emails === "object") {
                                    this.merchantConsolidationEmails = this.merchantInfo.config.merchant_consolidation_emails
                                } else {
                                    this.merchantConsolidationEmails = []
                                }
                            } else {
                                this.merchantConsolidationEmails = []
                            }

                        } else {
                          this.merchantInfo.config = {
                            has_shift : "false"
                          }
                          this.merchantHasFk = "nofk"
                          this.consolidationProcessTime = null
                          this.merchantConsolidationEmails = []
                        }

                        if (this.merchantInfo.status === 'active') {
                          this.business_status_disabled = true
                          this.has_shift_disabled = true
                        }

                        if (merchant.details !== null) {
                            if (merchant.details.address !== undefined)
                                this.merchantInfo.address = merchant.details.address
                            if (merchant.details.director_name !== undefined)
                                this.merchantInfo.directorName = merchant.details.director_name
                            if (merchant.details.director_identity_type !== undefined)
                                this.merchantInfo.directorIdentityType = merchant.details.director_identity_type
                            if (merchant.details.director_identity_number !== undefined)
                                this.merchantInfo.directorIdentityNumber = merchant.details.director_identity_number
                            if (merchant.details.mid_aino !== undefined)
                                this.merchantCredential.midAino = merchant.details.mid_aino
                            if (merchant.details.documents !== undefined)
                                this.merchantDocuments = merchant.details.documents
                        }
                    }

                    this.renderStatusUi(this.merchantInfo.status)
                }
            })
        }
    };
</script>

<style lang="scss">
    .con-input-upload {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 73px;
        text-align: left;
        margin: 0px;
        flex-direction: column;

        .text-input {
            text-align: left;
            width: 80%;
            display: block;
        }

        .vs-upload--button-upload {
            text-align: right;
            width: 20%;
            display: block;
            right: 0;
            bottom: auto;
            margin-right: 10px;
        }
    }

    /*css declaration generic for firefox and other browsers*/
    .vertical-center {
        position: absolute;
        margin-top: -3px;
        top: auto;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    /*css declaration only for Chrome/Safari*/
    @media (-webkit-min-device-pixel-ratio: 0) {
        .vertical-center {
            position: absolute;
            margin-top: 9px;
            top: auto;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
        }
    }
</style>



